import Vue from 'vue'
import VTooltip from 'v-tooltip'

// storybook
import AhaAudience from '@mindthegapstudio/stpancras-storybook-app/src/AhaAudience'

// Vue Click Outside
import vClickOutside from 'v-click-outside'

// Filter
import '@/filters'

// Vue resources
import VueResource from 'vue-resource'

// plugins
import functionsPlugin from '@/plugins/functions'

// 3rd parties
import sentry from '@/3rd-parties/sentry'

// Vue dialog
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// Vue glide
import VueGlide from 'vue-glide-js'

// Vue Toasted
import Toasted from 'vue-toasted'

import Config from '@/config'
import constants from '@/constant'

import mixpanelUtils from './utils/mixpanel.utils'
import preloadFont from './utils/font.preloader'
import store from './store'
import i18n from './i18n'
import router from './router'

import '@/assets/scss/normalize.scss'
import '@/assets/scss/animate2.css'
import '@/assets/scss/iconAnimate.scss'
import '@/assets/scss/dialog.scss'
import '@/assets/scss/checkbox.scss'
import '@/assets/css/font-awesome.min.css'
import '@/assets/scss/flex.scss'
import '@/assets/scss/variables.scss'
import '@/assets/scss/base.scss'
import '@/assets/scss/global.scss'
import '@/assets/scss/filestack.custom.scss'
import '@/assets/fontawesome/css/all.css'

import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

import 'emoji-mart-vue-fast/css/emoji-mart.css'
import 'vue-glide-js/dist/vue-glide.css'

import App from './App.vue'

Vue.config.productionTip = false
if (Config.env === 'staging' || Config.env === 'develop') {
  Vue.config.devtools = true
}

sentry.init()
mixpanelUtils.init()
Object.keys(constants.fonts).forEach((font) => {
  const fontConfig = constants.fonts[font]
  if (fontConfig.url) {
    preloadFont(fontConfig.url)
  }
})

// use custom plugins
Vue.use(functionsPlugin)

// use v-tooltip
Vue.use(VTooltip, {
  defaultOffset: 8,
  defaultTrigger: 'hover click',
})

// use storybook
Vue.use(AhaAudience)

Vue.use(vClickOutside)
Vue.use(VueResource)
Vue.use(VuejsDialog)
Vue.use(Toasted, {
  duration: 3000,
  singleton: true,
})
Vue.use(VueGlide)

// eslint-disable-next-line import/prefer-default-export
export const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
